class CategoryTabs extends HTMLElement {
  constructor() {
    super();

    this.buttons = [];
    this.panels = [];
    this.swipers = new Map();
    this.breakpoint = 990;
    this.onResize = this.onResize.bind(this);
  }

  connectedCallback() {
    this.cacheElements();
    this.bindEvents();
    this.setDefaultActive();
    this.initSliders();
    window.addEventListener('resize', this.onResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
    this.destroyAllSwipers();
  }

  cacheElements() {
    this.buttons = this.querySelectorAll('[data-tab-btn]');
    this.panels = this.querySelectorAll('[data-tab-panel]');
  }

  bindEvents() {
    this.buttons.forEach(button => {
      button.addEventListener('click', () => {
        this.activateTab(button.dataset.tabBtn);
      });
    });
  }

  setDefaultActive() {
    const hasActive = this.querySelector('[data-tab-btn].is-active');
    if (hasActive) return;

    // Fallback: active tab first
    const firstButton = this.buttons[0];
    if (firstButton) {
      this.activateTab(firstButton.dataset.tabBtn);
    }
  }

  activateTab(tabId) {
    if (!tabId) return;

    // Toggle buttons
    this.buttons.forEach(btn => {
      btn.classList.toggle(
        'is-active',
        btn.dataset.tabBtn === tabId
      );
    });

    // Toggle panels
    this.panels.forEach(panel => {
      const isActive = panel.dataset.tabPanel === tabId;
      panel.classList.toggle('is-active', isActive);
      if (isActive) {
        requestAnimationFrame(() => {
          this.initSlider(panel);

          const sliderEl = panel.querySelector('.swiper');
          const swiper = this.swipers.get(sliderEl);
          swiper?.update();
        });
      }
    });

    this.dispatchEvent(
      new CustomEvent('category-tab:change', {
        detail: { tabId },
        bubbles: true
      })
    );
  }
  initSliders() {
    this.panels.forEach(panel => {
      if (panel.classList.contains('is-active')) {
        this.initSlider(panel);
      }
    });
  }
  initSlider(panel) {
    const sliderEl = panel.querySelector('.swiper');
    if (!sliderEl) return;

    const slides = sliderEl.querySelectorAll('.swiper-slide');
    if (slides.length <= 1) return;

    // Desktop → destroy swiper
    if (window.innerWidth > this.breakpoint) {
      this.destroySlider(sliderEl);
      return;
    }

    // Mobile → init swiper
    if (this.swipers.has(sliderEl)) return;
    const prevEl = sliderEl.querySelector('.swiper-button-prev');
    const nextEl = sliderEl.querySelector('.swiper-button-next');

    const swiper = new Swiper(sliderEl, {
      slidesPerView: 1.2,
      spaceBetween: 16,
      freeMode: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      navigation: {
        prevEl,
        nextEl,
      },
      on: {
        init: () => this.toggleArrows(sliderEl),
        resize: () => this.toggleArrows(sliderEl),
      }
    });

    this.swipers.set(sliderEl, swiper);
  }

  destroySlider(sliderEl) {
    const swiper = this.swipers.get(sliderEl);
    if (!swiper) return;

    swiper.destroy(true, true);
    this.swipers.delete(sliderEl);
  }

  destroyAllSwipers() {
    this.swipers.forEach(swiper => swiper.destroy(true, true));
    this.swipers.clear();
  }

  onResize() {
    this.panels.forEach(panel => {
      if (panel.classList.contains('is-active')) {
        this.initSlider(panel);
      }
    });
  }
}

if (!customElements.get('category-tabs')) {
  customElements.define('category-tabs', CategoryTabs);
}